import React from "react";
import { Check } from "lucide-react";
import { Reveal } from "../lib/motion";
import { SECURITY, IMG } from "../data/site";

export const Security = () => {
  return (
    <section id="bezpieczenstwo" className="relative py-[clamp(64px,9vw,120px)] bg-surface/30 border-y border-white/10" data-testid="security-section">
      <div className="container-pm grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <Reveal className="order-2 lg:order-1">
          <div className="relative overflow-hidden rounded-2xl border border-white/10 aspect-[4/3]">
            <img
              src={IMG.security}
              alt="Umowa współpracy i ochrona danych PMPOINT"
              loading="lazy"
              className="w-full h-full object-cover"
              width="640"
              height="480"
            />
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="eyebrow mb-4">Bezpieczeństwo</p>
            <h2 className="font-display font-semibold text-white text-[clamp(30px,4vw,54px)] leading-[1.04] tracking-[-0.035em] mb-8">
              Bezpieczeństwo <span className="text-coral">i legalność</span> na każdym etapie.
            </h2>
          </Reveal>
          <ul className="space-y-4">
            {SECURITY.map((s, i) => (
              <Reveal as="li" key={s} delay={i * 0.08} y={16} className="flex items-start gap-3">
                <span className="shrink-0 mt-0.5 flex items-center justify-center w-6 h-6 rounded-full bg-coral/15 text-coral">
                  <Check size={14} strokeWidth={3} />
                </span>
                <span className="text-white/80">{s}</span>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
